import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'
import Vue from 'vue'

export const del = ({ commit }, item) => {
  commit(types.EXCMAGREEMENTCONSENT_DELETE_TOGGLE_LOADING)

  return fetch(item['@id'], { method: 'DELETE' })
    .then(() => {
      commit(types.EXCMAGREEMENTCONSENT_DELETE_TOGGLE_LOADING)
      commit(types.EXCMAGREEMENTCONSENT_DELETE_SET_DELETED, item)
    })
    .catch((e) => {
      commit(types.EXCMAGREEMENTCONSENT_DELETE_TOGGLE_LOADING)
      Vue.prototype.$Swal({
        type: 'error',
        title: Vue.prototype.$lang.t('notifications.store.errorTitle'),
        text: e.message,
        showConfirmButton: true
      })
      console.log(e.message)
      // commit(types.EXCMAGREEMENTCONSENT_DELETE_SET_ERROR, e.message)
    })
}

export const reset = ({ commit }) => {
  commit(types.EXCMAGREEMENTCONSENT_DELETE_RESET)
}
